import React from 'react'

import TopFilter from './TopFilter'

import { TOP_FILTERS } from '../../../slices/convo'
import useStyles from './styles'

interface ClientChatPanelProps {
  className?: string
  onClick?: () => void
}

const ClientChatPanel: React.FC<ClientChatPanelProps> = ({
  onClick,
  className
}) => {
  const classes = useStyles()

  return (
    <section className={className}>
      <TopFilter
        onClick={onClick}
        text={TOP_FILTERS.ALL}
        className={classes.marginTop}
      />

      <TopFilter onClick={onClick} text={TOP_FILTERS.ASSIGNED_TO_ME} />

      <TopFilter onClick={onClick} text={TOP_FILTERS.TRANSFERS} />

      <TopFilter onClick={onClick} text={TOP_FILTERS.OFFLINE} />
    </section>
  )
}

export default ClientChatPanel
